(ns minorodata.connections.sources.facebook-adinsights-oauth
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]
            [mold-forms.core :as form-component]))



(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description (spec/nilable string?))


(spec/def ::auth-credentials-id
  (spec/and (st/spec string? {:reason "Please provide a valid auth token"})
            (st/spec (complement c.string/blank?) {:reason "Please provide a valid auth token"})))


(spec/def ::auth-credentials
  (spec/keys :req-un [::auth-credentials-id]))


(spec/def ::facebook-adinsights-form
  (spec/keys :req-un [::name ::auth-credentials]
             :opt-un [::description]))

(def fields-options
  ["account_currency" "account_id" "account_name" "action_values" "actions"
   "ad_id" "ad_name" "adset_id" "adset_name" "attribution_setting"
   "buying_type"
   "campaign_id" "campaign_name" "canvas_avg_view_percent" "canvas_avg_view_time" "catalog_segment_value" "clicks"
   "conversion_rate_ranking" "conversion_values" "conversions" "converted_product_quantity" "converted_product_value"
   "cost_per_action_type" "cost_per_conversion" "cost_per_estimated_ad_recallers" "cost_per_inline_link_click"
   "cost_per_inline_post_engagement" "cost_per_outbound_click" "cost_per_thruplay" "cost_per_unique_action_type"
   "cost_per_unique_click" "cost_per_unique_inline_link_click" "cost_per_unique_outbound_click"
   "cpc" "cpm" "cpp" "ctr"
   "date_start" "dda_results"
   "engagement_rate_ranking" "estimated_ad_recall_rate" "estimated_ad_recallers"
   "frequency" "full_view_impressions" "full_view_reach"
   "impressions" "inline_link_click_ctr" "inline_link_clicks" "inline_post_engagement"
   "instant_experience_clicks_to_open" "instant_experience_clicks_to_start" "instant_experience_outbound_clicks"
   "mobile_app_purchase_roas"
   "objective" "optimization_goal" "outbound_clicks" "outbound_clicks_ctr"
   "purchase_roas"
   "qualifying_question_qualify_answer_rate" "quality_ranking"
   "reach"
   "social_spend" "spend"
   "video_30_sec_watched_actions" "video_avg_time_watched_actions" "video_p100_watched_actions"
   "video_p25_watched_actions" "video_p50_watched_actions" "video_p75_watched_actions" "video_p95_watched_actions"
   "video_play_actions" "video_play_curve_actions"
   "website_ctr" "website_purchase_roas"])


(def default-fields
  ["account_currency" "account_id" "account_name" "actions" "ad_id" "ad_name" "adset_id" "adset_name"
   "buying_type"
   "campaign_id" "campaign_name" "clicks" "cpc" "cpm"
   "date_start"
   "frequency"
   "impressions" "inline_link_clicks"
   "objective"
   "reach"
   "social_spend" "spend"])


(def source
  {:id           "facebook-adinsights-oauth"
   :enabled      false
   :name         "Facebook Adinsights oAuth (Deprecated)"
   :description  "Efficiently reach all of the people who matter most"
   :image-source "facebook.png"
   :tags         ["marketing"]

   :preview-formatter
   (fn []
     (str "Authenticated by token"))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [auth-credentials name description]} data]
        {:source-type "facebook-adinsights-oauth"
         :name        name
         :description description

         :source     {:auth-credentials-id (:auth-credentials-id auth-credentials)
                      :is-token-valid      (:is-token-valid auth-credentials)
                      :has-third-leg       true}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [auth-credentials-id is-token-valid]} source]
        {:name                name
         :description         description
         :auth-credentials    (when (and (some? auth-credentials-id)
                                         (some? is-token-valid))
                                {:auth-credentials-id auth-credentials-id
                                 :is-token-valid      is-token-valid})
         :auth-credentials-id auth-credentials-id
         :is-token-valid      is-token-valid}))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (partial form-component/validate-form ::facebook-adinsights-form)

    :id :facebook-adinsights-oauth-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             ;; https://developers.facebook.com/docs/facebook-login/manually-build-a-login-flow

             {:block-type :oauth
              :label      "Facebook Login"
              :name       :auth-credentials
              :required   true

              :request-uri      "https://www.facebook.com/v12.0/dialog/oauth"
              :params-processor (fn [{:keys [client-id redirect-uri state scope response-type]}]
                                  {:response_type response-type
                                   :scope         scope
                                   :client_id     client-id
                                   :redirect_uri  redirect-uri
                                   :state         state})

              :response-processor (fn [data]
                                    (select-keys data [:auth-credentials-id :is-token-valid]))


              :oauth-connector-type "facebook"
              :has-third-leg        true

              :response-type "code"
              :client-id     "3418646844834967"
              :scope         "ads_read"}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status destination-table
                 advanced-options level attribution-windows-view attribution-windows-click
                 history fields]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:action                    "append"
                    :destination-table         destination-table
                    :advanced-options          advanced-options
                    :level                     level
                    :attribution-windows-view  attribution-windows-view
                    :attribution-windows-click attribution-windows-click
                    :history                   history
                    :fields                    fields}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:destination-table :advanced-options :level
                               :attribution-windows-view :attribution-windows-click
                               :history :fields])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :facebook-adinsights-oauth-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}

             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :checkbox
              :label      "Advanced options"
              :name       :advanced-options
              :type       :checkbox
              :value      false}

             {:block-type :select
              :label      "Level"
              :name       :level
              :options    [{:name "Campaign" :value "campaign"}
                           {:name "Adset"    :value "adset"}
                           {:name "Ad"       :value "ad"}]
              :required   true
              :value      "campaign"
              :conditions [[:eq [:advanced-options :value] true]]}

             {:block-type :select
              :label      "Attribution Windows (View)"
              :name       :attribution-windows-view
              :options    [{:name "1d_view",  :value "1d_view"}
                           {:name "7d_view",  :value "7d_view"}
                           {:name "28d_view", :value "28d_view"}]
              :required   true
              :value      "1d_view"
              :conditions [[:eq [:advanced-options :value] true]]}

             {:block-type :select
              :label      "Attribution Windows (Click)"
              :name       :attribution-windows-click
              :options    [{:name "1d_click",  :value "1d_click"}
                           {:name "7d_click",  :value "7d_click"}
                           {:name "28d_click", :value "28d_click"}]
              :required   true
              :value      "7d_click"
              :conditions [[:eq [:advanced-options :value] true]]}

             {:block-type :select
              :label      "History"
              :name       :history
              :options    [{:name "1 month",   :value "1"}
                           {:name "3 months",  :value "3"}
                           {:name "6 months",  :value "6"}
                           {:name "9 months",  :value "9"}
                           {:name "12 months", :value "12"}
                           {:name "18 months", :value "18"}]
              :required   true
              :value      "3"
              :doc        [:span "Large backfills can cause extracts to take a long time or fail"]
              :conditions [[:eq [:advanced-options :value] true]]}

             {:content [:p "Note: If you are appending to a pre-created destination table, 
                            the fields you select should always match the columns of the destination table"]
              :conditions [[:eq [:advanced-options :value] true]]}
             
             {:block-type :multiselect
              :label      "Fields"
              :name       :fields
              :options    fields-options
              :value      default-fields
              :conditions [[:eq [:advanced-options :value] true]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
